import React from "react";

const Features = () => {
  return (
    <section className="bg-[#050505] px-4 py-8">
      <div className="mx-auto grid w-full max-w-[1800px] grid-cols-1 overflow-hidden rounded-2xl border border-[#c4dc5b]/30 bg-[#050505] shadow-[0_0_18px_rgba(196,220,91,0.12)] md:grid-cols-5">

        <div className="relative flex flex-col items-center px-6 py-12 text-center md:px-14 md:py-16">
                            <img
  src="logo54.png"
  alt="Growth"
  className="mb-5 h-20 w-[160px] object-contain"
/>
          <h3 className="mb-4 text-[17px] font-bold uppercase leading-tight tracking-wide text-white">
            AI-DRIVEN<br />INTELLIGENCE
          </h3>
          <p className="text-[14px] leading-7 text-white/70">
            Advanced AI models analyze markets 24/7 for smarter decisions.
          </p>

          <span className="absolute right-0 top-1/2 hidden h-[75%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent md:block" />
        </div>

        <div className="relative flex flex-col items-center px-6 py-12 text-center md:px-14 md:py-16">
                     <img
  src="chart.png"
  alt="Growth"
  className="mb-5 h-20 w-[160px] object-contain"
/>
          <h3 className="mb-4 text-[17px] font-bold uppercase leading-tight tracking-wide text-white">
            AUTOMATED<br />TRADING
          </h3>
          <p className="text-[14px] leading-7 text-white/70">
            Fully automated trading strategies for consistent performance.
          </p>

          <span className="absolute right-0 top-1/2 hidden h-[75%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent md:block" />
        </div>

        <div className="relative flex flex-col items-center px-6 py-12 text-center md:px-14 md:py-16">
               <img
  src="revenue.png"
  alt="Growth"
  className="mb-5 h-20 w-[160px] object-contain"
/>
          <h3 className="mb-4 text-[17px] font-bold uppercase leading-tight tracking-wide text-white">
            REAL REVENUE<br />GENERATION
          </h3>
          <p className="text-[14px] leading-7 text-white/70">
            Revenue generated from trading goes back to the ecosystem.
          </p>

          <span className="absolute right-0 top-1/2 hidden h-[75%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent md:block" />
        </div>

        <div className="relative flex flex-col items-center px-6 py-12 text-center md:px-14 md:py-16">
        <img
  src="stable.png"
  alt="Growth"
  className="mb-5 h-20 w-[120px] object-contain"
/>
          <h3 className="mb-4 text-[17px] font-bold uppercase leading-tight tracking-wide text-white">
            SUSTAINABLE<br />GROWTH
          </h3>
          <p className="text-[14px] leading-7 text-white/70">
            Built for long-term growth and community empowerment.
          </p>

          <span className="absolute right-0 top-1/2 hidden h-[75%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent md:block" />
        </div>

        <div className="flex flex-col items-center px-6 py-12 text-center md:px-14 md:py-16">
          <img
            src="community.png"
            alt="Future"
            className="mb-5 h-20 w-[250px] object-contain"
          />
          <h3 className="mb-4 text-[17px] font-bold uppercase leading-tight tracking-wide text-white">
            BUILT FOR<br />THE FUTURE
          </h3>
          <p className="text-[14px] leading-7 text-white/70">
            A strong community and a clear vision for the future of DeFi.
          </p>
        </div>

      </div>
    </section>
  );
};

export default Features;